<section class="pageTitle vh-70 d-flex align-items-center justify-content-center flex-column pt-5">
  <h1 class="mb-5" data-aos="fade-up" data-aos-duration="1000"> @if (isArabic) { دردشة مباشرة } @else { Live Chat } </h1> 
  <div>
      <span> <a routerLink="/home"> @if (isArabic) { الرئيسية } @else { Home } </a> </span>
      <b class="mx-2"> - </b> 
      <span> <a routerLink="/chat"> @if (isArabic) { دردشة مباشرة } @else { Live Chat } </a> </span>
   </div>
</section>

<section class="chat d-flex justify-content-center align-items-center min-vh-70">
    <!-- chat  -->

    <!-- @if(isLoaded){
      <div class="container chat-container">
        <div class="row">
          <div class="col-12 chat-box">
            <div class="chat-messages p-3 mb-3" #messagesBox dir="ltr" (scroll)="onScroll()">
              @if (messages.length==0) {
                <div class="text-center text-primary">
                  <i class="fa-solid fa-comments fs-1 mb-2"></i>
                  <h4 class="fst-italic"> @if (isArabic) { لا توجد دردشات بعد , كن أول من يرسل } @else { No Chats Yet , Be the first to send } </h4>
                </div>
              }
              @else {
                @for(message of messages; track $index){
                  <div class="message">
                      <img [src]="message.photoURL ? message.photoURL : 'assets/images/user-photo.png'" draggable="false" alt="{{ message.userName }}" width="40" height="40" class="profile-photo rounded-circle shadow-lg" />
                      <span class="user-name"> {{ message.userName }} : </span>
                      <span class="message-text"> {{ message.message }} </span>
                      <small class="text-muted float-right"> ({{ message.timestamp | date:'shortTime' }}) </small>
                  </div>
              }
              }
                <i class="fa-solid fa-caret-down toBottom shadow" (click)="scrollToBottom()"></i>
            </div>

               @if(isAuthenticated){
                <div class="chat-input">
                    <form [formGroup]="chatForm" (ngSubmit)="sendMessage()">
                        <input type="text" formControlName="message" [placeholder]="placeholderText" class="form-control"/>
                        <button type="submit" class="btn btn-primary mt-2" [disabled]="chatForm.invalid"> 
                          @if(isArabic){ إرسال } @else{ Send }  <i class="fa-solid fa-paper-plane"></i>
                        </button>
                      </form>
                </div>                  
               }
               @else {
                <div class="auth-prompt text-primary">
                    <p class="text-center"> @if (isArabic) { تحتاج إلى تسجيل الدخول لإرسال الرسائل . } @else { You need to sign in to send messages . } </p>
                    <button class="btn btn-primary" (click)="signInWithGoogle()"> @if (isArabic) { قم بتسجيل الدخول باستخدام جوجل } @else { Sign in with Google } </button>
                </div>
               }

          </div>
        </div>
      </div>
    }
    @else {
      <div class="fs-1 text-primary text-center">
        <i class="fa-solid fa-circle-notch fa-spin"></i>
        <br>
        <span class="fst-italic loading"> Loading </span>
      </div>
    } -->

    <!-- Comming Soon -->
    <div class="fs-1 text-primary text-center">
      <i class="fa-solid fa-circle-notch fa-spin"></i>
      <br>
      <span class="fst-italic loading"> @if (isArabic) { قريباً } @else { Comming Soon } </span>
    </div>
      
</section>